import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
export class Ng4SpinnerService {
public spinnerSubject = new BehaviorSubject<boolean>(false );
constructor() { }
/**
 * @return {?}
 */
hide() {
    this.spinnerSubject.next(false);
  }
/**
 * @return {?}
 */
show() {
    this.spinnerSubject.next(true);
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function Ng4SpinnerService_tsickle_Closure_declarations() {
/** @type {?} */
Ng4SpinnerService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Ng4SpinnerService.ctorParameters;
/** @type {?} */
Ng4SpinnerService.prototype.spinnerSubject;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
